var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pWalletMenu",
    class: _vm.isMobile && 'wap'
  }, [_c('div', {
    staticClass: "shadow",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return (() => _vm.$parent.pWalletMenuShow = false).apply(null, arguments);
      }
    }
  }), _c('div', {
    staticClass: "pWalletMenu-main",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return (() => {}).apply(null, arguments);
      }
    }
  }, _vm._l(_vm.menu, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "btn pWalletMenu-item",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.onSkip(item);
        }
      }
    }, [item.hasOwnProperty('icon') || item.icon === '' ? _c('svg-icon', {
      attrs: {
        "name": item.icon
      }
    }) : _vm._e(), _vm._v(" " + _vm._s(item.label) + " ")], 1);
  }), 0)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };